import React, { useState } from 'react'
import MovieRow from './MovieRow'
const MovieTable = ({ columns, data, onChange, onDelete, updatedMovieData11,
    rolename,
personIdval,
setLocalMode,
localMode,
setpersonIdval,
setRolename,
}) => {
    const [addedIndex, setAddedIndex] = useState()
    return (
      <div>
        <div style={{ float: 'right' }}>
          <br />
        </div>
        <table className='tableclassName mt-2'>
          <tbody>
            <tr
              className='red '
              style={{
                zIndex: '6',
                position: 'sticky',
                top: '0',
              }}
            >
              {columns.map(({ path, name }) => (
                <th
                  key={path}
                  className='tdclassName'
                  style={{ background: '#eee', border: '1px solid rgb(224, 224, 224)' }}
                >
                  {name}
                </th>
              ))}
            </tr>
            {data &&
              data.map((rowData, rowIndex) => {
                const handleChange = (columnIndex, changedData) => {
                  onChange?.(rowIndex, columnIndex, changedData)
                }

                const handleDelete = () => {
                  if (rowIndex !== addedIndex) {
                    setAddedIndex(addedIndex - 1)
                  }

                  onDelete?.(rowIndex, rowData)
                }

                return (
                  <MovieRow
                    rowIndex={rowIndex}
                    key={rowData[rowIndex]}
                    mode={addedIndex === rowIndex ? 'edit' : 'read'}
                    columns={columns}
                    data={rowData}
                    onChange={handleChange}
                    onDelete={handleDelete}
                    updatedMovieData11={updatedMovieData11}
                    rolename={rolename}
                    personIdval={personIdval}
                    setLocalMode={setLocalMode}
                    localMode={localMode}
                    setpersonIdval={setpersonIdval}
                    setRolename={setRolename}
                  />
                )
              })}
          </tbody>
        </table>
        <br />
      </div>
    )
  }

export default MovieTable
